import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import './styles.less';
import { Container, StyledModal } from './styles';
import closeIcon from './images/close-icon.svg';

const WistiaVideoModal = ({
  url,
  includesCta,
  isModalOpen,
  playAudioOnly,
  popoverContent,
  ratio,
  toggleIsModalOpen,
  setIsPlaying,
  videoId,
  videoPlayer,
  ...otherProps
}) => (
  <StyledModal
    onBackdropClick={() => {
      setIsPlaying(false);
      toggleIsModalOpen(false);
      videoPlayer?.pause();
    }}
    open={isModalOpen}
    width="max-content"
    {...otherProps}
    className={`${otherProps.className} ${playAudioOnly ? 'audio-only' : ''} video-modal`}
    hideCloseIcon
  >
    <Container ratio={ratio} includesCta={includesCta}>
      <button
        type="button"
        className="close"
        onClick={() => {
          setIsPlaying(false);
          toggleIsModalOpen(!isModalOpen);
          videoPlayer?.pause();
        }}
      >
        <img src={closeIcon} alt="close-icon" />
      </button>
      <div
        className={`wistia_embed wistia_async_${videoId} wistia-video autoPlay=true playbar=true settingsControl=true smallPlayButton=true fullscreenButton=true`}
      />
      {includesCta && popoverContent}
    </Container>
  </StyledModal>
);

export default WithWistiaContext(WistiaVideoModal);
